/* Copyright (c) 2017 Backpack Health LLC */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import MedliNames from '../../../../constants/MedliNames';
import HealthEntryIcons from '../../icons/HealthEntryIcons';
import AddMenu from './AddMenu';
import RouteNames from '../../../appAuthorized/RouteNames';
import { navigate } from '../../../appAuthorized/redux/NavigationActions';
import { actions as systemModalActions } from '../../../redux/ducks/systemModal';

const categories = [
  {
    category: MedliNames.category.condition,
    label: 'list.addMenuBackpack.conditions.name',
    icon: HealthEntryIcons.IconCondition,
  },
  {
    category: MedliNames.category.medication,
    label: 'list.addMenuBackpack.medications.name',
    icon: HealthEntryIcons.IconMedication,
  },
  {
    category: MedliNames.category.otherTreatment,
    label: 'list.addMenuBackpack.otherTreatments.name',
    icon: HealthEntryIcons.IconTreatment,
  },
  {
    category: MedliNames.category.procedure,
    label: 'list.addMenuBackpack.procedures.name',
    icon: HealthEntryIcons.IconProcedure,
  },
  {
    label: 'list.addMenuBackpack.allergies.name',
    icon: HealthEntryIcons.IconAllergy,
    categories: [
      { name: MedliNames.category.medicationAllergy, label: 'list.addMenuBackpack.allergiesMedication.name' },
      { name: MedliNames.category.foodAllergy, label: 'list.addMenuBackpack.allergiesFood.name' },
      { name: MedliNames.category.allergy, label: 'list.addMenuBackpack.allergiesOther.name' },
    ],
  },
  {
    category: MedliNames.category.vaccination,
    label: 'list.addMenuBackpack.vaccinations.name',
    icon: HealthEntryIcons.IconVaccination,
  },
  {
    category: MedliNames.category.measurement,
    label: 'list.addMenuBackpack.measurements.name',
    icon: HealthEntryIcons.IconMeasurement,
  },
  { category: MedliNames.category.lab, label: 'list.addMenuBackpack.labs.name', icon: HealthEntryIcons.IconLab },
  { category: MedliNames.category.gene, label: 'list.addMenuBackpack.genes.name', icon: HealthEntryIcons.IconGeneticResult },
];

interface Props {
  selectChoice(category): void;
}

interface State {
  expanded: { [category: string]: boolean };
}


function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    aaa: '',
    selectChoice: (choiceName) => {
      dispatch(systemModalActions.dismiss());
      navigate(RouteNames.createHealthEntry(choiceName));
    },
  };
}

class AddMenuHealthEntries extends React.Component<Props, State> {
  state: State = {
    expanded: {},
  };

  render() {
    const { selectChoice } = this.props;
    const { expanded } = this.state;

    return (
      <AddMenu>
        {
          categories.map(({ category, label, categories = [], icon: Icon }, idx) => (
            <div
              key={idx}
              className={cx('add-item font-color-profile-accent', { expanded: expanded[idx] })}
              onClick={category ? () => selectChoice(category) : () => this.expand(idx)}
            >
              <div className={category ? undefined : 'add-item-group'}>
                <FormattedMessage id={label}/>
              </div>

              <Icon color="middle-gray" size="24"/>

              {categories.map(({ name, label }, idx) => (
                <div key={idx} onClick={() => selectChoice(name)}>
                  <FormattedMessage id={label}/>
                </div>
              ))}
            </div>
          ))}
      </AddMenu>
    );
  }

  expand = (group) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [group]: true,
      },
    });
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuHealthEntries);
